import { Application } from "@hotwired/stimulus";
import HelloController from "./hello_controller.js";
import SubscriptionsController from "./subscriptions_controller.js";
import SubscriptionModalController from "./subscription_modal_controller.js";
import ProcessosChartController from "./processos_chart_controller.js";
import SchemaStorageChartController from "./schema_storage_chart_controller.js";

const application = Application.start();

application.register("hello", HelloController);
application.register("subscriptions", SubscriptionsController);
application.register("subscription-modal", SubscriptionModalController);
application.register("processos-chart", ProcessosChartController);
application.register("schema-storage-chart", SchemaStorageChartController);

window.Stimulus = application;
